// extracted by mini-css-extract-plugin
export default {"Seat":"Seat_Seat__fO+qD","seatNum":"Seat_seatNum__BFyMD","available":"Seat_available__q8liG","busy":"Seat_busy__b4cCY","selected":"Seat_selected__6NMIt"};